import { IApplicationState } from '../../types/redux';

export const getNewReviewAccessError = (state: IApplicationState) => {
  return state.newReview.meta.rejectAccessError;
};
